"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeHeaderCopy = exports.ThemeHeaderLayout = void 0;
var ThemeHeaderLayout;
(function (ThemeHeaderLayout) {
    ThemeHeaderLayout["Cobranded"] = "cobranded";
    ThemeHeaderLayout["SingleLogo"] = "singleLogo";
})(ThemeHeaderLayout = exports.ThemeHeaderLayout || (exports.ThemeHeaderLayout = {}));
var ThemeHeaderCopy;
(function (ThemeHeaderCopy) {
    ThemeHeaderCopy["Standard"] = "standard";
    ThemeHeaderCopy["SLR"] = "slr";
    ThemeHeaderCopy["ALR"] = "alr";
})(ThemeHeaderCopy = exports.ThemeHeaderCopy || (exports.ThemeHeaderCopy = {}));
//# sourceMappingURL=themeHeader.js.map